import { Guid, Nillable } from '@web/utils';
import { AdminBrandStatus } from '@web/shared/module/brand';

export class AdminBrandCollectionItem {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      createdAt: Date;
      homeUrl: Nillable<string>;
      id: Guid;
      logoAlt: Nillable<string>;
      logoUrl: Nillable<string>;
      name: string;
      status: AdminBrandStatus;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get homeUrl(): Nillable<string> {
    return this.data.homeUrl;
  }

  public get logoUrl(): Nillable<string> {
    return this.data.logoUrl;
  }

  public get logoAlt(): Nillable<string> {
    return this.data.logoAlt;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get status(): AdminBrandStatus {
    return this.data.status;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }
}
